<template>
  <div class="premium-type-badge">
    {{ $t(`global.premium`) }}
  </div>
</template>
<script>
export default {
  name: 'PremiumBadge',
}
</script>
<style lang="less" scoped>
@import '~@/assets/less/variables';

.premium-type-badge {
  padding: 0 8px;
  height: 20px;
  line-height: 20px;
  border-radius: 5px;
  font-size: 12px;
  font-weight: 500;
  color: white;
  background-color: #daa73b;
}
</style>
